import { BorderGridContainer, Button, Clickable, GridBox, H2, SpacerWrapper, TypeWrapper } from '@ahmdigital/ui';
import { isEmpty, isNil, map, take } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import type { CmsInsuranceTypeContent } from '../../types';

type FormsAndGuidesProps = CmsInsuranceTypeContent['formsAndGuides'];

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 3rem 0;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    flex-direction: row;
    margin: 1rem 6rem;
  }
`;

const StyledButtonWrapper = styled.div`
  flex-grow: 1;
  margin: 1rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    width: 25%;
  }

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    width: 20%;
  }
`;

const StyledButton = styled(Button)`
  height: 100%;

  > span {
    height: 100%;
  }
`;

const icon = { name: 'chevron-right', position: 'right', size: 'extraSmall' };

// @ts-expect-error - Automatic, Please fix when editing this file
const FormsAndGuides = ({ documents, heading, urlObject }: FormsAndGuidesProps) => {
  if (isEmpty(documents)) {
    return null;
  }

  const documentsToShow = take(4, documents);
  const url = urlObject?.url;

  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="1rem">
        <SpacerWrapper variant={['marginBottomSpacer2', 'marginTopSpacer2']}>
          <TypeWrapper variant={['center']}>
            <H2>{heading || 'Forms and guides'} </H2>
          </TypeWrapper>
          <Flex>
            {map(({ label, file, key }) => {
              if (isEmpty(file) || isNil(file?.asset?.url)) {
                return null;
              }

              return (
                <StyledButtonWrapper key={key}>
                  <StyledButton
                    analytics={{ label }}
                    icon={{ name: 'arrow-down', position: 'right' }}
                    to={file?.asset?.url}
                    variant={['border', 'transparentBlack', 'wide']}
                    height="100%"
                    inNewTab
                  >
                    {label}
                  </StyledButton>
                </StyledButtonWrapper>
              );
            }, documentsToShow)}
          </Flex>
          {!isNil(url) && (
            <TypeWrapper variant={['center']}>
              <Clickable icon={icon} to={url}>
                {urlObject?.name}
              </Clickable>
            </TypeWrapper>
          )}
        </SpacerWrapper>
      </GridBox>
    </BorderGridContainer>
  );
};

export default FormsAndGuides;
